/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type GetCardAccountTransactionsIntentOneOfItem = typeof GetCardAccountTransactionsIntentOneOfItem[keyof typeof GetCardAccountTransactionsIntentOneOfItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountTransactionsIntentOneOfItem = {
  charge: 'charge',
  refund: 'refund',
  topup: 'topup',
  withdraw: 'withdraw',
  repay: 'repay',
  cashback: 'cashback',
  interest: 'interest',
  transfer: 'transfer',
  fee: 'fee',
  other: 'other',
} as const;
